import { IMS_ENV } from "../constants";
import { IMSData } from "./ims";

export class ImsData {
  imslibData: IMSData = {
    token: null,
    tokenValid: false,
    isSignedInUser: false,
    reauthToken: null,
    tokenHasExpired: false,
    ready: false,
    error: null,
    profile: null,
    appState: null,
  };

  onStateChanged: Function | null = null;

  triggerOnStateChanged(newState: IMSData) {
    this.imslibData = { ...newState };
    if (this.onStateChanged) {
      this.onStateChanged(newState);
    }
  }

  constructor(onStateChanged: Function | null, adobeid: any = null) {
    this.onStateChanged = onStateChanged;
    if (adobeid) {
      this.adobeIdData = {
        ...this.adobeIdData,
        ...adobeid,
      };
    }
  }

  adobeIdData = {
    client_id: "adobedotcom_status",
    scope: "creative_cloud,AdobeID,openid,gnav,read_organizations,additional_info.projectedProductContext,additional_info.roles,additional_info.company,additional_info.ownerOrg,org.read,additional_info.account_type,pps.read",
    // imslib falls back to raw window.location.href whenever redirect_uri isn't explicitly
    // set here - including for its own internal/automatic checks, not just our signIn() calls.
    // Without this default, a leftover "#old_hash=...&from_ims=true" fragment on the page
    // gets fed straight back in and corrupts the next authorize URL it builds. Only strip
    // the hash when that corruption marker is actually present, so real deep links like
    // "#adminconsole"/"#myevents"/"#event" survive untouched.
    redirect_uri: typeof window !== 'undefined'
      ? (window.location.href.includes('from_ims=true')
          ? window.location.href.split('#')[0]
          : window.location.href)
      : undefined,
    locale: "en_US",
    environment: IMS_ENV,
    onAccessToken: (token: string) => {
      const imslibData = {
        ...this.imslibData,
        token,
        isSignedInUser: true,
      };
      this.triggerOnStateChanged(imslibData);
    },
    onAccessTokenHasExpired: () => {
      const imslibData = {
        ...this.imslibData,
        tokenHasExpired: true,
      };
      this.triggerOnStateChanged(imslibData);
    },
    onReauthAccessToken: (reauthToken: string) => {
      const imslibData = {
        ...this.imslibData,
        reauthToken,
        isSignedInUser: true,
      };
      this.triggerOnStateChanged(imslibData);
    },
    onError: (errortype: any, error: any) => {
      const imslibData = {
        ...this.imslibData,
        error: {
          errortype,
          error,
        },
      };
      this.triggerOnStateChanged(imslibData);
    },
    onReady: (context: any) => {
      const imslibData = {
        ...this.imslibData,
        ready: true,
        appState: context,
      };
      this.triggerOnStateChanged(imslibData);
    },
    onProfile: (profile: any) => {
      const imslibData = {
        ...this.imslibData,
        profile,
      };
      this.triggerOnStateChanged(imslibData);
    },
  };

  onTokenValid = (valid: boolean) => {
    const imslibData = {
      ...this.imslibData,
      tokenValid: valid,
      isSignedInUser: true,
    };
    this.triggerOnStateChanged(imslibData);
  };
}
